var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChannelDashboardClosedTicketsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_289",
    x: 0,
    y: 0,
    width: 79,
    height: 79,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#64c95c",
    floodOpacity: 0.208
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161870",
    "data-name": "Group 161870",
    transform: "translate(-199 -577)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 199, 577)",
    filter: "url(#Ellipse_289)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_289-2",
    "data-name": "Ellipse 289",
    cx: 30.5,
    cy: 30.5,
    r: 30.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "open-access-svgrepo-com",
    d: "M23.168,13.647a8.6,8.6,0,0,0-.64-1.217V8.257a7.386,7.386,0,0,0-2.235-5.29,7.713,7.713,0,0,0-10.771,0,7.372,7.372,0,0,0-2.23,5.29V12.43h3.051V8.257a4.408,4.408,0,0,1,1.34-3.171,4.583,4.583,0,0,1,7.793,3.171V9.493A9.113,9.113,0,0,0,8.538,10.841a8.722,8.722,0,0,0,0,12.479,9.083,9.083,0,0,0,12.7,0,8.73,8.73,0,0,0,1.924-9.678Zm-8.276,9.264a5.828,5.828,0,1,1,5.93-5.827A5.887,5.887,0,0,1,14.892,22.911Zm2.546-5.8c0,3.294-5.031,3.294-5.031,0S17.438,13.812,17.438,17.111Z",
    transform: "translate(223.61 600.155)",
    fill: "#70b577"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelDashboardClosedTicketsIcon);
export default __webpack_public_path__ + "static/media/channel-dashboard-closed-tickets-icon.05119ddd6a809b517751bb3ba31a6e17.svg";
export { ForwardRef as ReactComponent };